import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ProposalShortlistItem } from '../../models/mercer-support-incumbent-member.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-positions-overlay',
  templateUrl: './positions-overlay.component.html',
  styleUrls: ['./positions-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})
export class PositionsOverlayComponent {
  readonly finalIncumbentPositions = input<ProposalShortlistItem[] | undefined>(undefined);
  readonly shortlistedOnOpenPositions = input<ProposalShortlistItem[] | undefined>(undefined);
  readonly shortlistedOnClosedPositions = input<ProposalShortlistItem[] | undefined>(undefined);
}
